import validator from 'email-validator';
import { checkDateFormat, getDateDiff } from 'libs/common';

export function isValidEmail(email) {
  return validator.validate(email);
}

export function validateEmail(email = '') {
  if (!email.trim()) {
    return 'libs.validator.message.required';
  } else if (!isValidEmail(email)) {
    return 'libs.validator.message.invalidEmail';
  }
  return '';
}

export function validatePassword(password = '') {
  if (!password.trim()) {
    return 'libs.validator.message.required';
  } else if (password.length < 6) {
    return 'libs.validator.message.invalidPassword';
  }
  return '';
}

export function validatePasswordRedemptionAuth(password = '') {
  if (!password.trim()) {
    return 'libs.validator.message.required';
  } else if (password.length < 6) {
    return 'libs.validator.message.invalidPassword.redemptionAuth';
  }
  return '';
}

export function validateFieldForRequired(activationCode = '') {
  if (!activationCode.trim()) {
    return 'libs.validator.message.required';
  }
  return '';
}

export function validateFieldForDob(dob = '') {
  let error = '';
  if (!dob.trim()) {
    error = 'libs.validator.message.required';
  } else if (!checkDateFormat(dob)) {
    error = 'libs.validator.message.invalidDob.format';
  }

  const diff = getDateDiff(dob);
  if (diff < 17) {
    error = 'libs.validator.message.invalidDob.ageLimit';
  }
  return error;
}

export function validateFieldForZipCode(val = '', country_code) {
  const _countryCode = country_code || 'US';
  const zipCodeValidationObj = {
    'CA': {
      zipCodeRegex: /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/, errorMessage: 'libs.validator.message.invalidZipCode.CA'
    },
    'US': { zipCodeLength: 5, zipCodeRegex: /^\d+$/, errorMessage: 'libs.validator.message.invalidZipCode.US' }
  };

  let error = '';
  if (!val.trim()) {
    error = 'libs.validator.message.required';
  } else if ((zipCodeValidationObj[_countryCode].zipCodeLength
    && val.length !== zipCodeValidationObj[_countryCode].zipCodeLength) ||
    !(zipCodeValidationObj[_countryCode].zipCodeRegex.test(val))) {
    error = zipCodeValidationObj[_countryCode].errorMessage;
  }

  return error;
}

export function validateFieldPhoneNumber(val = '') {
  let error = '';
  const regex = /^[+]?[0-9]\d{9,14}$/;

  if (!val.trim()) {
    error = 'libs.validator.message.required';
  } else if (!regex.test(val)) {
    error = 'libs.validator.message.invalidPhoneNumber';
  }

  return error;
}

export default {
  isValidEmail,
  validateEmail,
  validatePassword,
  validateFieldForRequired,
  validateFieldForZipCode,
  validateFieldPhoneNumber
};



// WEBPACK FOOTER //
// ./src/libs/validator.js